import { httpsCallable } from "firebase/functions";
import { functions, initTenantFirebase } from "../utils/firebase";

export const initTenant = async (clientId) => {
  await initTenantFirebase(clientId);
};

export const getDocumentByIdAndSigner = async (documentId, signerToken) => {
  try {
    const callable = httpsCallable(functions, "getDocumentByIdAndSigner");
    const response = await callable({ documentId, signerToken });
    return response.data; // innehåller dokumentdata + signer + downloadUrl
  } catch (error) {
    console.error("Error fetching document:", error);
    throw error;
  }
};

export const getPdf = async (downloadUrl) => {
  const getPdfFn = httpsCallable(functions, "getPdf");
  const result = await getPdfFn({ downloadUrl });
  const arrayBuffer = Uint8Array.from(atob(result.data.base64), (c) =>
    c.charCodeAt(0)
  ).buffer;
  return arrayBuffer;
};

export const signDocument = async (
  documentId,
  signerToken,
  name,
  filledData,
  signature
) => {
  try {
    const callable = httpsCallable(functions, "signDocument");
    const response = await callable({
      documentId,
      signerToken,
      name,
      filledData,
      signature, // base64-data:image/png,... från signaturePad
    });
    return response.data;
  } catch (error) {
    console.error("Error signing document:", error);
    throw error;
  }
};
